import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';

/**
 * Resend email verification code during setup
 */
export default function useResendEmailSetupCode() {
  return useToastedMutation({
    mutationFn: async () => {
      return post<never, void>('/api/auth/mfa/email/resend', undefined as never);
    },
    successToastMessage: 'Verification code resent to your email',
    errorToastMessage: 'Failed to resend code. Please try again.',
  });
}
